<template>
  <v-dialog v-model="dialog">
    <v-card>
      <v-card-title>
        Satın Alma Sipariş Detayı
        <v-spacer></v-spacer>
        <v-btn @click="dialog = false" color="danger darken-1" style="color: white;">
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="mb-4 d-flex justify-content-start py-1">
          <div class="d-flex w-100 flex-column ps-4"
               style="font-size:12px;border-left: 5px solid grey;border-bottom: 5px solid grey">
            <div class="py-3"><b>Tedarikçi Kodu : </b> {{ purchaseOrderItemDetails.supplierCode }}</div>

            <div class="py-3"><b>Tedarikçi Adı : </b> {{ purchaseOrderItemDetails.supplierName }}</div>

            <div class="py-3"><b>Plasiyer Kodu : </b>{{ purchaseOrderItemDetails.salesPersonCode }}</div>

            <div class="py-3"><b>Plasiyer Adı : </b>{{ purchaseOrderItemDetails.salesPersonName }}</div>


            <div class="py-3"><b>Sipariş Tarihi : </b> {{ formattedDate(purchaseOrderItemDetails.date) }}
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end mb-2">
          <div class="mr-3" >
            <v-select
                :items="[
                      {value: 6, text: 'Teslim Edildi'},
                      {value: 5, text: 'Gönderildi'},
                      {value: 4, text: 'Hazırlanıyor'},
                      {value: 3, text: 'Reddedildi'},
                      {value: 2, text: 'Onaylandı'},
                      {value: 1, text: 'Sipariş Verildi'}
                  ]"
                style="width:163px; height: 36px;"
                v-model="allStatus"
                label="Durum Güncelle"
                item-text="text"
                item-value="value"
                solo
                hide-details
                dense
            >

            </v-select>
          </div>
          <v-btn color="info darken-1" @click="updateAllStatus" > Tüm Siparişleri Güncelle</v-btn>
        </div>
        <b-table
            :items="purchaseOrderItemDetails.orderItems"
            :fields="purchaseOrderItemDetailsHeaders"
            :busy="purchaseOrderItemDetailsLoading"
            hover
            show-empty
            responsive
            head-row-variant="info"
            table-variant="white"
            :per-page="perPage"
            :current-page="currentPage"
        >
          <template #empty="scope">
            <h6 class="text-center my-5">
              {{ scope.loading ? "Lütfen Bekleyin" : noPurchaseOrderItemDetailsMessage ? noPurchaseOrderItemDetailsMessage : "Veri Yok"}}
            </h6>
          </template>
          <template #cell(unitPrice)="data">
            {{ numberConverter(data.item.unitPrice) + ' ' +  fetchCurrencyLabel(data.item.currencyType) }}
          </template>
          <template #cell(amount)="data">
            {{ numberConverter(data.item.amount) + ' ' + fetchCurrencyLabel(data.item.currencyType) }}
          </template>
          <template #cell(stockName)="data">
            {{data.item.stockName}}
            <p class="mb-0 fs-6" v-if="data.item.producerCode">
              Üretici Kodu :
              <span class="fw-medium fs-7">{{ data.item.producerCode }}</span>
            </p>
          </template>
          <template #table-busy>
            <div class="text-center">
              <b-spinner
                  variant="primary"
                  size="lg"
              ></b-spinner>
            </div>
          </template>


          <template #cell(status)="data">
            <div style="text-align: -webkit-center;">
              <v-select
                  :items="[
                      {value: 6, text: 'Teslim Edildi'},
                      {value: 5, text: 'Gönderildi'},
                      {value: 4, text: 'Hazırlanıyor'},
                      {value: 3, text: 'Reddedildi'},
                      {value: 2, text: 'Onaylandı'},
                      {value: 1, text: 'Sipariş Verildi'}
                  ]"
                  style="width:163px;margin: 0 3px; margin-left: 2px;"
                  v-model="data.item.itemStatus"
                  label=""
                  item-text="text"
                  item-value="value"
                  filled
                  solo
                  hide-details
                  dense
                  @change="changeStatus(data.item.id, $event)"
              >

              </v-select>
            </div>
          </template>

        </b-table>
        <div>
          <div class="row justify-content-end">
            <div class="col-lg-4 table-responsive">
              <table class="table table-sm mb-0">
                <tbody>
                <tr>
                  <td>Brüt Tutar</td>
                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.grossAmount) }} ₺</td>
                </tr>
                <tr>
                  <td>İskonto</td>
                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.discount) }} ₺</td>
                </tr>
                <tr>
                  <td>Ara Toplam</td>
                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.subTotal) }} ₺</td>
                </tr>
                <tr>
                  <td>KDV</td>
                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.vat) }} ₺</td>
                </tr>
                <tr>
                  <th>Toplam Tutar :</th>
                  <th class="text-right">{{ numberConverter(purchaseOrderItemDetails.totalAmount) }} ₺</th>
                </tr>
                </tbody>
              </table>
<!--              <hr>-->
<!--              <table class="table table-sm mb-0">-->
<!--                <tbody>-->
<!--                <tr>-->
<!--                  <td>Dövizli Brüt Tutar</td>-->
<!--                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.currencyGrossAmount) }}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>Dövizli İskonto</td>-->
<!--                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.currencyDiscount) }}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>Dövizli Ara Toplam</td>-->
<!--                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.currencySubTotal) }}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <td>Dövizli KDV</td>-->
<!--                  <td class="text-right">{{ numberConverter(purchaseOrderItemDetails.currencyVat) }}</td>-->
<!--                </tr>-->
<!--                <tr>-->
<!--                  <th>Dövizli Toplam Tutar</th>-->
<!--                  <th class="text-right">{{ numberConverter(purchaseOrderItemDetails.currencyTotalAmount) }}</th>-->
<!--                </tr>-->
<!--                </tbody>-->
<!--              </table>-->
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center ">
          <div class="exclude-print mt-4">
            <v-btn v-if="(userRoleId=== '1' || userRoleId === 1)"
                   class="mx-2" text color="success darken-1" @click="_approveOrder" :loading="loading">
              <v-icon left>mdi-check-decagram</v-icon>
              Onayla
            </v-btn>
            <ExcelExport
                :dataProp="purchaseOrderItemDetails.orderItems"
                :column-prop="purchaseOrderItemDetailsHeaders"
            >

            </ExcelExport>
            <PrintPage :divId="'printDiv'"></PrintPage>
            <v-btn @click="dialog = false" class="mx-2 text-white" text color="danger darken-1">
              <v-icon left>mdi-close</v-icon>
              Kapat
            </v-btn>
          </div>

        </div>

      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import {numberConverter} from "../../../../../helpers";
import {swalToast} from "@/helpers/swalToast";
import {formattedDate} from "@/momentHelper";
import ExcelExport from "@/components/shared/ExcelExport.vue";
import PrintPage from "@/components/shared/PrintPage";

export default {
  name: "PurchaseOrderDetailDialog",
  components: {
    ExcelExport,
    PrintPage
  },
  methods: {
    formattedDate,
    numberConverter,
    ...mapActions("order", ["itemStatusChange","orderStatusChange","fetchSinglePurchaseOrder","approvePurchaseOrder"]),
    changeStatus(id, status) {
      this.itemStatusChange({params: {orderItemId: id, status: status}});
    },
    updateAllStatus() {
      if (!this.allStatus) swalToast.fire({icon: "error", title: "Lütfen bir durum seçiniz"});
      else {
        this.orderStatusChange({params: {orderId: this.purchaseOrderItemDetails.id, status: this.allStatus}}).then(async () => {
          await this.fetchSinglePurchaseOrder({params: {} , body:{}, urlSegments:[this.purchaseOrderItemDetails.id] });
        })
      }
    },
    fetchCurrencyLabel(currencyType) {
      for (const item of this.currencyLabels) {
        if (item.id === currencyType) {
          return item.label;
        }
      }
      return `₺`;
    },
    async _approveOrder() {
      this.loading = true;
      await this.approvePurchaseOrder({
        params: {},
        body: {},
        urlSegments: [this.purchaseOrderItemDetails.id]
      });
      this.loading = false;
      await this.$parent.$parent._fetchPurchaseOrders();
      this.dialog = false;
    },
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    ...mapState("order", ["purchaseOrderItemDetails","purchaseOrderItemDetailsHeaders","purchaseOrderItemDetailsLoading","purchaseOrders","noPurchaseOrderItemDetailsMessage"]),
    ...mapGetters("settings", ["getCurrencyLabels"]),
    currencyLabels: {
      get() {
        return this.getCurrencyLabels;
      },
    },
  },
  data () {
    return {
      dialog: false,
      perPage: 10,
      currentPage: 1,
      allStatus: null,
      userRoleId: this.$store.state.auth.user.RoleGroupId,
      loading: false,
    }
  },
  watch: {
    "dialog": function (newVal) {
      this.$emit("dialogChange", newVal)
    },
    "showDialog": function (newVal) {
      this.dialog = newVal
    },
  }
}
</script>

<style scoped>

</style>